import { useEffect, useState } from "react";
import { PENALTY_TYPES } from "./penaltiesData";
import { loadPenaltyTypes } from "./penaltiesApi";

// Penalty Type options for the Add / Edit form and the import, loaded from
// GET payroll/deduction/penalty/types/ each time `open` turns true. Until
// they arrive, or if the call fails or returns nothing, the built-in
// PENALTY_TYPES are used so the form still works.
export const usePenaltyTypes = (domain, open) => {
  const [types, setTypes] = useState(PENALTY_TYPES);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !domain) return undefined;
    const controller = new AbortController();
    setLoading(true);
    loadPenaltyTypes(domain, controller.signal)
      .then((list) => { if (!controller.signal.aborted) setTypes(list.length ? list : PENALTY_TYPES); })
      .catch(() => { if (!controller.signal.aborted) setTypes(PENALTY_TYPES); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [open, domain]);

  return { types, loading };
};
